export const meta: BlockMeta = {
  title: "Numbered Rows",
  description: "A numbered stack of rows with body content",
  keywords: ["content"],
  cache: false,
  tags: ["root"],
  conditions: {
    postTypes: ["page", "post", "article", "hall-of-fame", "resource"],
  },
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/numbered-rows", (props) => {
  return (
    <div className="nested-ordered-list">
      <ol>
        <InnerBlocks allowedBlocks={["content/numbered-rows-item"]} template={[["content/numbered-rows-item", null]]} orientation="vertical" />
      </ol>
    </div>
  )
})
